import { Box, Pagination, Stack, Tab, Tabs } from '@mui/material';
import { Container } from 'Components/Container';
import {
  MenuNotificationBody,
  MenuNotificationContent,
  MenuNotificationIcon,
  MenuNotificationItem,
  MenuNotificationTime,
  MenuNotificationTitle,
} from 'Components/Header/components/MenuNotifications/style';
import { TabPanel } from 'Components/TabPanel';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { getUserNotifications } from 'services/user-notifications-service';
import { useAuthTenant, useAuthUser } from 'store/auth';
import InboxIcon from '@mui/icons-material/Inbox';
import { formatDateTimeToDateTimeBR } from 'utils/date_utils';

export const UserNotifications = () => {
  const user = useSelector(useAuthUser);
  const selectedTenant = useSelector(useAuthTenant);
  const [tabPosition, setTabPosition] = useState(0);
  const [page, setPage] = useState(1);

  const {
    data: notification,
    isLoading,
    isError,
  } = useQuery(['getNotifications', user, selectedTenant, page], async () => {
    if (selectedTenant.slug === undefined || selectedTenant.slug === null) return [];

    const result = await getUserNotifications(user.userId, selectedTenant.slug, page, 15, '');

    if (result.status === 200) {
      return {
        notifications: result.data.data,
        page: result.data.page,
        totalPages: result.data.totalPages,
      };
    }
    return {
      notifications: [],
      page: 1,
      totalPages: 0,
    };
  });
  return (
    <Container title="Notificações" linkPage="/user-notifications">
      <Box sx={{ width: '100%' }} className="container">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabPosition}
            onChange={(_, newValue) => setTabPosition(newValue)}
            aria-label="Abas das notificações"
          >
            <Tab
              label="Não lidas"
              id="tab-news"
              aria-controls="tabpanel-news"
              style={{ marginLeft: 0, marginTop: 0, width: 'fit-content' }}
            />
            <Tab
              label="Lidas"
              id="tab-readed"
              aria-controls="tabpanel-readed"
              style={{ marginLeft: 0, marginTop: 0, width: 'fit-content' }}
            />
            <Tab
              label="Arquivadas"
              id="tab-archived"
              aria-controls="tabpanel-archived"
              style={{ marginLeft: 0, marginTop: 0, width: 'fit-content' }}
            />
          </Tabs>
        </Box>
        <TabPanel padding={'8px 0px'} value={tabPosition} index={0} id="tabpanel-news" ariaLabel="tab-news">
          {!isLoading && !isError && (
            <>
              {notification?.notifications?.map((itemNotification, key) => (
                <MenuNotificationItem key={`notification-news-${key}`}>
                  <MenuNotificationIcon>
                    <InboxIcon />
                  </MenuNotificationIcon>
                  <MenuNotificationBody>
                    <MenuNotificationTitle>{itemNotification.titleNotification}</MenuNotificationTitle>
                    <MenuNotificationContent>{itemNotification.bodyNotification}</MenuNotificationContent>
                    <MenuNotificationTime>
                      {formatDateTimeToDateTimeBR(itemNotification.createdDate, true)}
                    </MenuNotificationTime>
                  </MenuNotificationBody>
                </MenuNotificationItem>
              ))}
              <Stack sx={{ justifyContent: 'center', flexDirection: 'row', marginTop: '16px' }}>
                <Pagination
                  count={notification.totalPages}
                  onChange={(_, selectedPage) => {
                    setPage(selectedPage);
                  }}
                  color="primary"
                  page={notification.page}
                  showFirstButton
                  showLastButton
                />
              </Stack>
            </>
          )}
        </TabPanel>
        <TabPanel value={tabPosition} index={0} id="tabpanel-readed" ariaLabel="tab-readed"></TabPanel>
        <TabPanel value={tabPosition} index={0} id="tabpanel-archived" ariaLabel="tab-archived"></TabPanel>
      </Box>
    </Container>
  );
};
